import React from "react";
import { StyledLabel, StyledListItem } from "./setup.style";
import { ReactComponent as UnCheckedIcon } from "./img/UnChecked_icon.svg";
import { ReactComponent as CheckedIcon } from "./img/Checked_Icon.svg";

const ListItem = ({ checked, label, comment }) => {
	return (
		<StyledListItem>
			{checked ? <CheckedIcon /> : <UnCheckedIcon />}
			<StyledLabel checked={checked}>
				{label} <span>{comment}</span>
			</StyledLabel>
		</StyledListItem>
	);
};
export default ListItem;
